<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col md="8" lg="8" xl="6">
        <v-card>
          <v-card-title>
            <span class="font-weight-regular">{{ formTitle }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
          ></v-progress-linear>
          <v-card-text class="pa-5">
            <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
              <v-text-field
                tabindex="1"
                v-model="name_th"
                :rules="[(v) => !!v || 'โปรดระบุชื่อ']"
                label="ชื่อ"
                required
                clearable
                @change="checkEmpty($event, 'name_th')"
              ></v-text-field>
              <v-text-field
                tabindex="2"
                v-model="name_en"
                label="ชื่อ (อังกฤษ)"
                clearable
                @change="checkEmpty($event, 'name_en')"
              ></v-text-field>
              <v-dialog
                ref="dialogDateExpire"
                v-model="modalDateExpire"
                :return-value.sync="expire"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    tabindex="3"
                    v-model="expire"
                    label="วันหมดอายุ"
                    append-icon="mdi-calendar"
                    @click:append="modalDateExpire = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="expire" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalDateExpire = false"
                    >Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogDateExpire.save(expire)"
                    >OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <div class="mt-5">
                <v-btn
                  tabindex="4"
                  type="submit"
                  class="mr-4"
                  color="primary"
                  @click="onSubmit"
                  :disabled="loading"
                  >Create Access Token
                </v-btn>
                <v-btn tabindex="5" :disabled="loading" @click="onCancel"
                  >ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" v-if="drawer"></v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="480px">
      <v-card>
        <v-card-title>
          <span>Access Token</span>
        </v-card-title>
        <v-card-text class="py-0">
          <v-text-field
            ref="textToCopy"
            v-model="accessToken"
            single-line
            append-icon="mdi-content-copy"
            hide-details
            class="mb-1"
            @click:append="copyAccessToken"
          ></v-text-field>
          <span class="caption red--text">{{ accessTokenMessage }}</span>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pa-5">
          <v-btn @click="onCancel">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      accessToken: '',
      accessTokenMessage: 'โปรดคัดลอก access token',
      formTitle: '',
      loading: false,
      name_th: '',
      name_en: '',
      expire: '',
      modalDateExpire: false,
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer
    },
  },
  created() {
    if (this.$route.name === 'AccessTokenAdd') {
      this.$store.commit('SET_BREADCRUMBS', [
        { text: 'หน้าหลัก', disabled: false, to: '/' },
        {
          text: 'สิทธิ์ความปลอดภัย',
          disabled: false,
          to: '/access-token',
        },
        {
          text: 'เพิ่ม access token',
          disabled: true,
        },
      ])

      this.formTitle = 'เพิ่ม access token'
    }
  },
  methods: {
    ...mapActions({
      createAccessToken: 'accessToken/createAccessToken',
    }),
    copyAccessToken() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    onCancel() {
      this.$router.push({ path: '/access-token' })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const newAccessToken = {
          name_th: this.name_th,
          name_en: this.name_en,
          created: new Date(),
          expire: this.expire,
        }

        this.createAccessToken(newAccessToken)
          .then(({ key }) => {
            this.loading = false

            this.accessToken = key
            this.dialog = true
          })
          .catch((error) => {
            this.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this[field] = value.trim()
      }
    },
  },
}
</script>
